// src/pages/admin/Dashboard.jsx
import React from 'react';

export default function Dashboard() {
  return (
    <div>
      <h2>Dashboard</h2>
      <p>Welcome to the admin dashboard. Manage users, groups, and advertisements from here.</p>
    </div>
  );
}
